"use client";

import { SVGProps } from "react";
import { svg, SvgName } from "@/svg";

export type VectorProps = SVGProps<SVGElement> & {
  className?: string;
  name: SvgName;
};

export const Vector = ({ className = "", name, ...rest }: VectorProps) => {
  const Component = svg[name];

  if (!Component) {
    return null;
  }

  return (
    <Component
      {...rest}
      className={`${className} shrink-0 select-none outline-none`}
      aria-hidden="true"
      focusable="false"
      tabIndex={-1}
    />
  );
};
